import { FC } from 'react';

import { useGetPartnersSectionPermissions } from 'modules/partners/hooks/useGetPartnerSectionsPermissions';
import { NotesSectionProvider } from 'modules/notes/components/NotesSection/context/NotesSectionContext';
import { ObservationsSectionProvider } from 'modules/observations/components/ObservationsSection/context/ObservationsSectionContext';
import ObservationsSection from 'modules/observations/components/ObservationsSection';
import NotesSection from 'modules/notes/components/NotesSection';

import { NoteReference } from 'types/Note';
import CustomMovementsSection from '../CustomMovementsSection';
import { CustomMovementsSectionProvider } from '../CustomMovementsSection/context/CustomMovementsSectionContext';

type PartnerObservationsProps = {
  partnerId: string;
};

const PartnerObservations: FC<PartnerObservationsProps> = ({ partnerId }) => {
  const { data: permissionsData } = useGetPartnersSectionPermissions();

  return (
    <>
      <NotesSectionProvider
        referenceId={partnerId}
        referenceType={NoteReference.PARTNER}
        permissions={permissionsData}
      >
        <NotesSection />
      </NotesSectionProvider>

      <ObservationsSectionProvider
        referenceId={partnerId}
        referenceType={NoteReference.PARTNER}
        permissions={permissionsData}
      >
        <ObservationsSection />
      </ObservationsSectionProvider>

      <CustomMovementsSectionProvider partnerId={partnerId}>
        <CustomMovementsSection />
      </CustomMovementsSectionProvider>
    </>
  );
};

export default PartnerObservations;
